import { authenticatedPost } from '../../../../../api/request';

export default async function saveNewAd(saveData, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error guardando el nuevo anuncio.');
    const url = '/ads/';
    return await authenticatedPost(url, onFail, saveData);
}
